import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

import { Button, Props as ButtonProps } from '../../atoms/Button'
import { styled } from '../../../styled'

type Props = ButtonProps & {
  icon: IconProp
}

const Text = styled.span`
  margin-left: 8px;
`

export const IconButton: React.FC<Props> = ({
  bgColor,
  block,
  children,
  className,
  disabled,
  icon,
  onClick,
  size,
}) => (
  <Button
    bgColor={bgColor}
    block={block}
    className={className}
    disabled={disabled}
    onClick={onClick}
    size={size}
  >
    <FontAwesomeIcon icon={icon} fixedWidth />
    {children && <Text>{children}</Text>}
  </Button>
)
